import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface FlipCalendarIconProps extends SvgIconProps {}

export const FlipCalendarIcon = ({
  style,
  ...iconProps
}: FlipCalendarIconProps): ReactElement => {
  style = {
    fontSize: '1em',
    ...style,
  };

  return (
    <SvgIcon style={style} {...iconProps} viewBox="0 0 20.59 19.006">
      <path
        d="M21.985,6.75h-1.98V7.938a.4.4,0,0,1-.4.4h-.792a.4.4,0,0,1-.4-.4V6.75h-9.5V7.938a.4.4,0,0,1-.4.4H7.731a.4.4,0,0,1-.4-.4V6.75H5.355a1.986,1.986,0,0,0-1.98,1.98V22.192a1.986,1.986,0,0,0,1.98,1.98h16.63a1.986,1.986,0,0,0,1.98-1.98V8.73A1.986,1.986,0,0,0,21.985,6.75Zm.4,14.849a.993.993,0,0,1-.99.99H5.949a.993.993,0,0,1-.99-.99V12.689a.4.4,0,0,1,.4-.4h16.63a.4.4,0,0,1,.4.4Z"
        transform="translate(-3.375 -5.166)"
        fill="#383838"
      />
      <path
        d="M10.584,4.9a.4.4,0,0,0-.4-.4H9.4a.4.4,0,0,0-.4.4V6.084h1.584Z"
        transform="translate(-5.04 -4.5)"
        fill="#383838"
      />
      <path
        d="M26.334,4.9a.4.4,0,0,0-.4-.4h-.792a.4.4,0,0,0-.4.4V6.084h1.584Z"
        transform="translate(-9.703 -4.5)"
        fill="#383838"
      />
    </SvgIcon>
  );
};
